import React from 'react';
import { TrendingUpIcon } from 'lucide-react';
const ProfileEfficacyWidget = () => {
  // Weekly impact score
  const score = 87;
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden h-full p-6" data-id="element-735">
      <div className="flex flex-col h-full" data-id="element-736">
        <h2 className="text-base font-semibold text-gray-800 mb-6" data-id="element-737">
          Impatto Settimanale
        </h2>
        <div className="flex flex-col" data-id="element-738">
          <div className="flex items-baseline justify-between mb-2" data-id="element-739">
            <div className="text-lg font-medium text-gray-800" data-id="element-740">{score}%</div>
            <div className="text-sm text-gray-600" data-id="element-741">impatto settimanale</div>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2 mb-6" data-id="element-742">
            <div className="bg-custom-green h-2 rounded-full" style={{
            width: `${score}%`
          }} data-id="element-743"></div>
          </div>
          <div className="space-y-4" data-id="element-744">
            <div className="flex justify-between items-center" data-id="element-745">
              <span className="text-sm text-gray-600" data-id="element-746">Partecipazione</span>
              <span className="text-sm font-medium text-gray-800" data-id="element-747">92%</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-748">
              <span className="text-sm text-gray-600" data-id="element-749">Interazioni</span>
              <span className="text-sm font-medium text-gray-800" data-id="element-750">85%</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-751">
              <span className="text-sm text-gray-600" data-id="element-752">Contributi</span>
              <span className="text-sm font-medium text-gray-800" data-id="element-753">84%</span>
            </div>
          </div>
        </div>
        <div className="mt-auto pt-6 text-sm text-gray-500 flex items-center" data-id="element-754">
          <TrendingUpIcon size={16} className="text-custom-green mr-2" data-id="element-755" />
          <span data-id="element-756">Top 5% nella community</span>
        </div>
      </div>
    </div>;
};
export default ProfileEfficacyWidget;